module.exports = __webpack_public_path__ + "static/media/biometrics.5deb6d51.svg";